
import React from "react";
import { useSelector } from "react-redux";

const Shop = () => {
    const selectedLang = useSelector((state) => state.language.selectedLang);

    return (
        <div className="relative min-h-screen bg-[#f9f7ef] overflow-hidden select-none flex items-center justify-center">
            <h1 className="text-5xl md:text-7xl font-bold text-gray-800 font-canto">
                {selectedLang === "मराठी" ? "लवकरच येत आहे..." : "Coming Soon..."}
            </h1>
        </div>
    );
};

export default Shop;
